import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "hint" }, "или", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "blue_btn"
}, "Выбрать из списка черновиков", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "blue_btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go_step1()))
      }, " Создать новый "),
      _hoisted_3,
      _hoisted_4
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go_back()))
    }, "Назад")
  ], 64))
}